<template>
	<section class="page">
		<div class>
			<h2 v-if="info.name">{{info.name}}</h2>
		</div>
		<el-tabs v-model="activeName" v-loading="loadings.dm">
			<el-tab-pane label="基础信息" name="info">
				<info-table
					ref="baseInfoTable"
					class="content-box"
					data-model-name="User"
					:record-id="recordId"
					:fields="infoFields"
					:auto-load="false"
				></info-table>
			</el-tab-pane>
			<el-tab-pane label="报名" name="books">
				<curd-table
					ref="listTable"
					data-model="Book_item"
					:fields="tableFields"
					:kv-filter="{
				active: { k: 'customer', t: 'id', v: recordId, lge: '==' },
			}"
					@doedit="handleEdit($event)"
					:hasDelete="false"
				></curd-table>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			data-model-name="Book_item"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
		></editor>
	</section>
</template>

<script>
import InfoTable from "@/components/InfoTable.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import CurdPage from "@/mixins/CurdPage.js";
import TabPage from "@/mixins/TabPage.js";
import Filters from "@/mixins/Filters.js";

export default {
	mixins: [CurdPage, TabPage, Filters],
	data() {
		return {
			loadings: {
				dm: false,
			},

			recordId: "",
			activeName: "info",
			info: {},
			listOrderOps: [
				{
					name: "info",
					show_name: "详情",
					handler: "goinfo",
				},
			],
			orderSumFields: [
				{
					name: "count",
					title: "数量(笔)",
				},
				{
					name: "sum_total_price",
					title: "总价(￥)",
				},
			],
			infoFields: [
				[
					{
						name: "name",
						col: 2,
					},
					{
						name: "phone",
						col: 2,
					},
					{
						name: "vip_level",
						col: 2,
					},
					{
						name: "cardid",
						col: 2,
					},
				],
			],
			tableFields: [
				{
					name: "active",
				},
				{
					name: "name",
				},
				{
					name: "color",
					sortable: "custom",
				},
				{
					name: "model",
					sortable: "custom",
				},
				{
					name: "store",
					sortable: "custom",
				},

				{
					name: "created_at",
					sortable: "custom",
				},
			],
			editorFields: [
				{
					name: "name",
					isOnlyShow: true,
				},
				{
					name: "active",
					sortable: "custom",
					isOnlyShow: true,
				},
				{
					name: "is_must_win",
					sortable: "custom",
				},
			],
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),
	},
	created() {},
	mounted() {
		this.refreshData();
	},
	methods: {
		refreshData() {
			this.recordId = this.$route.params.id;
			this.$set(this.kvFilter, "customer", {
				k: "customer",
				t: "id",
				v: this.recordId,
			});
			this.baseKv = [{ k: "customer", t: "id", v: this.recordId }];
			this.loadings.main = true;
			this.$axios
				.post(`/curd/edit/user/${this.recordId}`)
				.then(json => {
					this.info = Object.assign({}, json.data.info);
					this.$refs["baseInfoTable"].setData(json.data.info);
					this.loadings.main = false;
				})
				.catch(json => {
					this.loadings.main = false;
				});
		},
		goOrderLink(id, data) {
			this.$router.push({
				name: "Order-Info",
				params: {
					id: id,
				},
			});
		},
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: "refreshData",
	},
	components: {
		InfoTable,
	},
};
</script>
<style lang="scss" scoped>
</style>
